import React, { useState, useEffect } from "react";
import { Formik } from "formik";
import { FilterModal, DatePicker, SelectSearch } from "components";
import { DateConvert } from "utilities";
import Axios from "axios";
import { CloseSalesOrderApi } from "api";

const ModalFilter = ({ show, setShow, data, setData }) => {
  // STATE DATA
  const [dataCustomer, setDataCustomer] = useState([
    { label: "Semua", value: undefined },
  ]);

  const [loading, setLoading] = useState(true);
  // FORM VALUES
  const formInitialValues = {
    tgl_sales_order_mulai: data?.filter?.tgl_sales_order_mulai,
    tgl_sales_order_selesai: data?.filter?.tgl_sales_order_selesai,
    tgl_close_sales_order_mulai: data?.filter?.tgl_close_sales_order_mulai,
    tgl_close_sales_order_selesai: data?.filter?.tgl_close_sales_order_selesai,
    id_customer: data?.filter?.id_customer,
  };
  const formSubmitHandler = (values) => {
    const checkActive =
      !!Object.values(values).filter((val) => val !== undefined).length > 0;

    if (checkActive) {
      setData({
        filter: {
          ...values,
          active: true,
        },
        pagination: {
          ...data.pagination,
          page: 1,
        },
      });
    } else {
      setData({
        ...data,
        filter: {
          ...values,
          active: false,
        },
      });
    }

    setShow(false);
  };
  const onTanggalCloseSalesOrderChange = (dates, values, setValues) => {
    const [start, end] = dates;
    const startDate = start ? DateConvert(start).default : null;
    const endDate = end ? DateConvert(end).default : null;

    setValues({
      ...values,
      tgl_sales_order_mulai: startDate,
      tgl_sales_order_selesai: endDate,
    });
  };
  const onTanggalSalesOrderChange = (dates, values, setValues) => {
    const [start, end] = dates;
    const startDate = start ? DateConvert(start).default : null;
    const endDate = end ? DateConvert(end).default : null;

    setValues({
      ...values,
      tgl_close_sales_order_mulai: startDate,
      tgl_close_sales_order_selesai: endDate,
    });
  };

  // REQUSET DATA SERVER
  const getDataDropdown = () => {
    Axios.all([CloseSalesOrderApi.getDropdownCustomer()])
      .then(
        Axios.spread((customer) => {
          const mapDataCustomer = customer?.data?.data
            ? customer.data.data.map((val) => ({
                label: val?.nama_customer,
                value: val?.id_customer,
              }))
            : [];

          setDataCustomer([...dataCustomer, ...mapDataCustomer]);
        })
      )
      .finally(() => setLoading(false));
  };

  const onResetButtonClick = (values, setValues) => {
    setValues({
      tgl_sales_order_mulai: undefined,
      tgl_sales_order_selesai: undefined,
      tgl_close_sales_order_mulai: undefined,
      tgl_close_sales_order_selesai: undefined,
      id_customer: undefined,
    });
  };

  useEffect(() => {
    getDataDropdown();

    return () => {};
  }, []);

  return (
    <Formik
      enableReinitialize
      initialValues={formInitialValues}
      onSubmit={formSubmitHandler}
    >
      {({ values, handleSubmit, setFieldValue, setValues }) => (
        <FilterModal
          show={show}
          setShow={setShow}
          onResetButtonClick={() => onResetButtonClick(values, setValues)}
          onFilterButtonClick={handleSubmit}
        >
          <DatePicker
            selectsRange
            label="Tgl. Sales Order"
            placeholderText="DD/MM/YYYY - DD/MM/YYYY"
            startDate={
              values.tgl_sales_order_mulai
                ? new Date(values.tgl_sales_order_mulai)
                : ""
            }
            endDate={
              values.tgl_sales_order_selesai
                ? new Date(values.tgl_sales_order_selesai)
                : ""
            }
            onChange={(dates) =>
              onTanggalCloseSalesOrderChange(dates, values, setValues)
            }
            monthsShown={2}
          />
          <DatePicker
            selectsRange
            label="Tgl. Close Sales Order"
            placeholderText="DD/MM/YYYY - DD/MM/YYYY"
            startDate={
              values.tgl_close_sales_order_mulai
                ? new Date(values.tgl_close_sales_order_mulai)
                : ""
            }
            endDate={
              values.tgl_close_sales_order_selesai
                ? new Date(values.tgl_close_sales_order_selesai)
                : ""
            }
            onChange={(dates) =>
              onTanggalSalesOrderChange(dates, values, setValues)
            }
            monthsShown={2}
          />

          <SelectSearch
            key={values.id_customer}
            label="Customer"
            placeholder="Pilih Item Produksi"
            defaultValue={dataCustomer.find(
              (val) => val.value === values.id_customer
            )}
            option={dataCustomer}
            onChange={(val) => setFieldValue("id_customer", val.value)}
            loading={loading}
          />
        </FilterModal>
      )}
    </Formik>
  );
};
export default ModalFilter;
